import * as yup from "yup";

/**
 * @description - Validation schema for organization form
 */
export default yup.object({
  name: yup.string().min(4).required(),
});
